@if (isAnnotationsLoading || isDocumentLoading) {
  <mat-progress-bar matLine mode="indeterminate"></mat-progress-bar>
}

<!-- Hide the viewer module while we load the document and annotation data. -->
<div
  class="hidden-viewer-container"
  [ngClass]="{
    'hidden-viewer': isAnnotationsLoading || isDocumentLoading,
  }"
>
  <!-- Render the selected viewer module here. -->
  @if (usePdfJs) {
    <ng2-pdfjs-viewer
      viewerId="pdf-preview-viewer"
      downloadFileName="Square9Download.pdf"
      [pdfSrc]="(pdfSrc$ | async) ?? ''"
      [openFile]="false"
      (onDocumentLoad)="onPdfJsDocumentLoad()"
      (onScaleChange)="onPdfJsDocumentScaleChange($event)"
      [page]="1"
      [zoom]="userDefaultZoom"
      (onPageChange)="onPageChange($event)"
      #pdfPreviewViewer
    ></ng2-pdfjs-viewer>
  } @else {
    <app-toolbar></app-toolbar>
    @if (loadingProgressPercentage !== 100) {
      <mat-progress-bar
        matLine
        [mode]="loadingProgressPercentage === 0 ? 'query' : 'determinate'"
        [value]="loadingProgressPercentage"
      ></mat-progress-bar>
    }
    <pdf-viewer
      [src]="(pdfSrc$ | async) ?? ''"
      [render-text]="true"
      [original-size]="false"
      (after-load-complete)="onLoadComplete($event)"
      (on-progress)="onProgress($event)"
      [(page)]="pageNumber"
      [zoom]="zoomScale"
    ></pdf-viewer>
  }
</div>

<!-- Basic viewer module. @see ng2-pdf-viewer -->

<!-- PDF.js based viewer module (default, advanced). @see @kariudo/ng2-pdfjs-viewer -->
